import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/icon/warning.png'


const _hoisted_1 = { class: "accessories-reminder" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: "accessories reminder"
}, null, -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "accessories-setting" }

import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  table: {
    type: Array,
    default: () => ([])
  }
},
  emits: ['update:visible'],
  setup(__props, { emit: emits }) {





return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "accessories-dialog",
    "model-value": __props.visible,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emits('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('系统查询到您有辅料未添加到附加项配置')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('setupShop', { query: { type: 'ShopAddition' }}))))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('去配置')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})